import type { SortDirection } from 'providers/tanstack-query/table'

export const REPORT_STATUSES = [
  'queued',
  'running',
  'failed',
  'succeeded',
  'dead-lettered',
  'timed-out',
  'consent-blocked-direct',
  'consent-blocked-proxied',
] as const

export type ReportStatus = (typeof REPORT_STATUSES)[number]

export const IN_PROGRESS_REPORT_STATUSES = [
  'queued',
  'running',
  'failed',
] as const satisfies readonly ReportStatus[]

export const REPORT_FORMATS = ['html', 'json'] as const

export type ReportFormat = (typeof REPORT_FORMATS)[number]

export const REPORT_SORT_FIELDS = ['createdAt', 'url'] as const

export type CreateReportBody = Pick<Report, 'url'>

export type CreateReportResponse = Pick<Report, 'jobId'>

export type ListReportsParams = {
  limit: number
  offset: number
  sortBy: ReportSortField
  sortDirection: SortDirection
  url?: string
}

export type ListReportsResponse = {
  items: Report[]
  total: number
}

export type Report = {
  createdAt: string
  jobId: string
  reportLinks: ReportLinks
  status: ReportStatus
  url: string
}

export type ReportDetails = Report & {
  devices: null | ReportDeviceState[]
  error: null | string
  updatedAt: string
}

export type ReportSortField = (typeof REPORT_SORT_FIELDS)[number]

type ReportDevice = 'desktop' | 'mobile'

type ReportDeviceState = {
  consentAttempts: null | number
  device: ReportDevice
  tokenUsage: null | ReportTokenUsage
}

type ReportLinks = Record<ReportFormat, null | string>

type ReportTokenUsage = {
  browserAgent: number
  summaryAgent: number
}
